import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCityBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "#262626",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 7H2V22H9V7Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 2H9V22H22V2Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 6H12V7H14V6Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 6H17V7H19V6Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 14H12V15H14V14Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 14H17V15H19V14Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 10H12V11H14V10Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 10H17V11H19V10Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 18H12V19H14V18Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 18H17V19H19V18Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 14H5V15H6V14Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 10H5V11H6V10Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 18H5V19H6V18Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
export default SvgCityBuilding;
